export const educationData = [
    // {
    //     id: 1,
    //     institution: 'SMK Negeri 6 Surabaya',
    //     course: 'Pastry',
    //     startYear: '2011',
    //     endYear: '2014'
    // },
    {
        id: 1,
        institution: 'Universitas Wijaya Kusuma Surabaya',
        course: 'Bachelor of Education - BEd, English Education',
        startYear: '2016',
        endYear: '2020'
        
    },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]